<template>
  <v-chip :color="chipColor" text-color="white" small class="text-uppercase font-weight-medium glass-effect-chip" label>
    {{ category }}
  </v-chip>
</template>

<script>
import CATEGORIA from '@/modules/notificaciones/domain/categoria'

export default {
  props: {
    category: {
      type: String,
      required: true,
      validator: (value) => {
        return Object.values(CATEGORIA).includes(value)
      },
    },
  },

  computed: {
    chipColor() {
      switch (this.category) {
        case CATEGORIA.INFORMATIVA:
          return 'teal'
        case CATEGORIA.ALERTA:
          return 'purple'
        case CATEGORIA.RECORDATORIO:
          return 'indigo'
        default:
          return 'grey'
      }
    },
  },
}
</script>

<style scoped>
.glass-effect-chip {
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(255, 255, 255, 0.18) !important;
  box-shadow: 0 4px 12px 0 rgba(31, 38, 135, 0.25) !important;
  transition: all 0.3s ease !important;
}

.glass-effect-chip:hover {
  box-shadow: 0 8px 16px 0 rgba(31, 38, 135, 0.37) !important;
  transform: translateY(-1px);
}

.glass-effect-chip.v-chip.v-chip--small {
  border-radius: 16px;
  font-weight: 500 !important;
  letter-spacing: 0.5px;
  padding: 0 12px !important;
}

/* Customize colors with glass effect */
.glass-effect-chip.v-chip.teal {
  background: linear-gradient(135deg, rgba(0, 150, 136, 0.85), rgba(0, 150, 136, 0.65)) !important;
  border: 1px solid rgba(0, 150, 136, 0.3) !important;
}

.glass-effect-chip.v-chip.purple {
  background: linear-gradient(135deg, rgba(156, 39, 176, 0.85), rgba(156, 39, 176, 0.65)) !important;
  border: 1px solid rgba(156, 39, 176, 0.3) !important;
}

.glass-effect-chip.v-chip.indigo {
  background: linear-gradient(135deg, rgba(63, 81, 181, 0.85), rgba(63, 81, 181, 0.65)) !important;
  border: 1px solid rgba(63, 81, 181, 0.3) !important;
}

.glass-effect-chip.v-chip.grey {
  background: linear-gradient(135deg, rgba(158, 158, 158, 0.85), rgba(158, 158, 158, 0.65)) !important;
  border: 1px solid rgba(158, 158, 158, 0.3) !important;
}
</style>
